import Totals from "../model/crew/Totals";
import BigNum from "../model/math/BigNum";
import StatisticsIncrementor from "../model/statistics/StatisticsIncrementor";
import Values from "../model/value/Values";
import { Settings } from "../Settings";
import TimeFormatter from "../util/TimeFormatter";

export default class OfflineLogic {
    /**
     * @param {Totals} totals 
     * @param {Values} values
     * @param {StatisticsIncrementor} statisticsIncrementor
     */
    constructor(totals, values, statisticsIncrementor) {
        /**
         * @constant
         * @type {Totals}
         */
        this.totals = totals;
        /**
         * @constant
         * @type {Values}
         */
        this.values = values;
        /**
         * @constant
         * @type {StatisticsIncrementor}
         */
        this.statisticsIncrementor = statisticsIncrementor;
        /**
         * @constant
         * @type {BigNum}
         */
        this.tempFormatValue = new BigNum(0);

        /**
         * @constant
         * @type {BigNum}
         */
        this.workingOre = new BigNum(0);
        /**
         * @constant
         * @type {BigNum}
         */
        this.workingPrestige = new BigNum(0);
        /**
         * @constant
         * @type {BigNum}
         */
        this.workingGold = new BigNum(0);
        /**
         * @constant
         * @type {BigNum}
         */
        this.workingRuby = new BigNum(0);
    }

    /**
     * @param {Totals} totals 
     * @param {Values} values
     */
    calculateOfflineEarnings() {

        const offlineSeconds = this.totals.offlineSeconds;
        if (offlineSeconds <= 0) {
            return;
        }

        console.log('OfflineLogic.calculateOfflineEarnings() offlineSeconds=' + TimeFormatter.formatElapsedTime(offlineSeconds * 1000));

        const offlineTurns = offlineSeconds * Settings.time.turnsPerSecond;

        const maxOfflineTurns = Settings.offline.defaultOfflineTurns + (this.values.offlineTimeUpgrades.getValue() * Settings.offline.turnsPerUpgrade);
        
        const countedTurns = Math.min(maxOfflineTurns, offlineTurns);

        if (countedTurns <= 0) {
            // Clear out the offline seconds.
            this.totals.offlineSeconds = 0;
            this.totals.countedOfflineSeconds = 0;
            return;
        }

        this.calculateOfflineCurrency(countedTurns, this.totals.prestigePerTurn, this.workingPrestige);
        if (this.workingPrestige.greaterThanZero()) {
            this.totals.incrementOfflinePrestige(this.workingPrestige);
        }

        this.calculateOfflineCurrency(countedTurns, this.totals.goldPerTurn, this.workingGold);
        if (this.workingGold.greaterThanZero()) {
            this.totals.incrementOfflineGold(this.workingGold);
        }


        this.calculateOfflineCurrency(countedTurns, this.totals.rubyPerTurn, this.workingRuby);
        if (this.workingRuby.greaterThanZero()) {
            this.totals.incrementOfflineRuby(this.workingRuby);
        }

        this.calculateOfflineCurrency(countedTurns, this.totals.orePerTurn, this.workingOre);
        if (this.workingOre.greaterThanZero()) {
            this.totals.incrementOfflineOre(this.workingOre);
        }

        this.totals.countedOfflineSeconds = (countedTurns * Settings.time.secondsPerTurn) | 0;
        this.totals.offlineSeconds = 0;
    }

    claimOfflineEarnings() {
        this.totals.countedOfflineSeconds = 0;
        
        this.statisticsIncrementor.incrementPrestigePoints(this.totals.offlinePrestige);
        this.totals.prestige.add(this.totals.offlinePrestige);
        this.totals.prestigePointsSum.add(this.totals.offlinePrestige);
        this.totals.offlinePrestige.setZero();

        this.statisticsIncrementor.incrementGold(this.totals.offlineGold);
        this.totals.gold.add(this.totals.offlineGold);
        this.totals.offlineGold.setZero();

        this.statisticsIncrementor.incrementOre(this.totals.offlineOre);
        this.totals.ore.add(this.totals.offlineOre);
        this.totals.offlineOre.setZero();
        
        this.statisticsIncrementor.incrementRuby(this.totals.offlineRuby);
        this.totals.ruby.add(this.totals.offlineRuby);
        this.totals.offlineRuby.setZero();
    }


    /**
     * @private
     * @param {number} offlineTurns 
     * @param {BigNum} currencyPerTurn
     * @param {BigNum} offlineCurrency
     */
    calculateOfflineCurrency(offlineTurns, currencyPerTurn, offlineCurrency) {
        if (currencyPerTurn.equalsZero()) {
            offlineCurrency.setZero();
            return;
        }

        offlineCurrency.copy(currencyPerTurn);
        offlineCurrency.mulNumber(offlineTurns);
        offlineCurrency.floor();
    }

}